<template>
    <div class="absolute z-20 translate-y-[-100%] w-[300px] tablet:hidden" :class="{'translate-x-[-100%]': shouldPositionLeft}" :style="{left: left}">
        <div class="px-2 py-0.5 shadow-md text-xs text-white bg-barometer-orange" :class="{'mr-2 rounded-l': shouldPositionLeft, 'ml-2 rounded-r': !shouldPositionLeft}">{{shownLabel}}</div>
        <span class="w-2 absolute shadow-md bg-barometer-orange h-full top-1" :class="{'right-0 skew-y-[45deg]': shouldPositionLeft, 'left-0 skew-y-[-45deg]': !shouldPositionLeft}"></span>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useDetailStore} from "../../store";

export default defineComponent({
    name: "tracker-info",
    props: {
        label: {
            type: String,
            required: true
        },
        position: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            detailStore: useDetailStore(),
            maxLabelWidth: 300      
        }
    },
    computed: {
        left(): string {
            const offsetDueToBarWidth = this.shouldPositionLeft ? 0 : 2;
            return this.position + offsetDueToBarWidth + 'px';
        },
        shownLabel(): string {
            return this.label.truncate(45);
        },
        shouldPositionLeft(): boolean {
            return this.position > (this.detailStore.wrapperWidth - this.maxLabelWidth);
        }
    }
});
</script>
